import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AUTH_PROVIDERS, useAuthProvider } from "../Authentication/AuthProviderSwitch";

const SubscribePage = () => {
  const location = useLocation();
  const { isAuthenticated, provider } = useAuthProvider();
  const query = new URLSearchParams(location.search);
  const planId = query.get("planId");
  const purchasesPath = `/client/purchases${planId ? `?planId=${encodeURIComponent(planId)}&source=pricing` : "?source=pricing"}`;

  if (provider !== AUTH_PROVIDERS.CLERK) {
    return <Navigate to="/login" replace />;
  }

  if (isAuthenticated) {
    return <Navigate to={purchasesPath} replace />;
  }

  return <Navigate to={`/client/sign-up?returnTo=${encodeURIComponent(purchasesPath)}`} replace />;
};

export default SubscribePage;
